module.exports = __webpack_public_path__ + "243d54910ebf63f5f34e2f0fee1be7ed.pdf";